export default __webpack_public_path__ + "static/media/accumulatorscfg_card.f8673c06.jpg";